export const ObtenerEstadoPilona = (estado) => {
        let estadoActual = {
            nombre: '',
            imagen: ''
        };
    switch (estado) {
        case 0:
            estadoActual = {
                nombre: 'Abierta',
                imagen: 'pilona_abierta'
            }
            break
        case 1:
            estadoActual = {
                nombre: 'Cerrada',
                imagen: 'pilona_cerrada'
            }
            break
        case 2:
            estadoActual = {
                nombre: 'Normal',
                imagen: 'pilona_normal'
            }
            break
        case 3:
            estadoActual = {
                nombre: 'Carga/Descarga',
                imagen: 'pilona_carga_descarga'
            }
            break
        case 4:
            estadoActual = {
                nombre: 'En Mantenimiento',
                imagen: 'pilona_nocomunica'
            }
            break
        case 5:
            estadoActual = {
                nombre: 'Local',
                imagen: 'pilona_normal'
            }
            break
        case 6:
            estadoActual = {
                nombre: 'Controlada->Libre ',
                imagen: 'pilona_normal'
            }
            break
        default:
            estadoActual = {
                nombre: 'Estado desconocido',
                imagen: 'pilona_nocomunica'
            }
    }
        return estadoActual;
};